import { Component, EventEmitter, Input, Output } from '@angular/core';

import { getTimeZoneDisplayName } from '../../../../../utils';


/** A date + time pair for a booking deadline, read in `timeZone` (PRO-1537). */
@Component({
  selector: 'app-deadline-date-time-input',
  templateUrl: './deadline-date-time-input.component.html',
})
export class DeadlineDateTimeInputComponent {
  public readonly getTimeZoneDisplayName = getTimeZoneDisplayName;

  @Input() idPrefix: string;
  @Input() timeZone: string | null = null;
  @Input() disabled = false;

  @Input() date = '';
  @Output() dateChange = new EventEmitter<string>();

  @Input() time = '';
  @Output() timeChange = new EventEmitter<string>();

  public onDateChange(date: string) {
    this.date = date;
    this.dateChange.emit(date);

    // A picked day most often means "by the end of that day".
    if (date && !this.time) {
      this.onTimeChange('23:59');
    }

    // Clear on the date picker shouldn't strand the auto-filled time behind it.
    if (!date && this.time === '23:59') {
      this.onTimeChange('');
    }
  }

  public onTimeChange(time: string) {
    this.time = time;
    this.timeChange.emit(time);
  }
}
